import { fetchDevicePageApi } from './devicePageApi'

export const useFetchDevicePage = function () {
  return {
    fetchDevicePage: fetchDevicePageApi, // Just return the plain function
  }
}
